module.exports = __webpack_public_path__ + "img/media_facwbook_nor.9a68044d.svg";